import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Salutation } from './salutation.interface';
import { SalutationService } from './salutation.service';

const service = new SalutationService();

export interface SalutationState {
   salutations: Array<Salutation>;
}

const SalutationStore: Module<SalutationState, StoreState> = {
   namespaced: true,
   state: {
      salutations: [],
   },
   getters: {
      salutations: (state) => state.salutations,
   },
   mutations: {
      SET_SALUTATIONS(state, salutations: Array<Salutation>) {
         state.salutations = salutations;
      },
   },
   actions: {
      async getSalutations(context, query: LocationQuery) {
         const response = await service.getSalutations({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_SALUTATIONS', response.data);
         return response;
      },
   },
};

export default SalutationStore;
